// @ts-check
import { ref } from "vue";
import { LOAD_STATE } from "bto-models/utils/index.js";
import QuickLinksRequest from '@bto-services/api/shared/quick-links.request';

/**
 * @type {import('./interface').QuickLinksStoreRef}
 */
export const quickLinksStore = ref({
  loadState: LOAD_STATE.INITAL,
  links: [],
});

/**
 * Get quick links from SB 
 */
export function getQuickLinks() {
  if (quickLinksStore.value.loadState === LOAD_STATE.LOADED || quickLinksStore.value.loadState === LOAD_STATE.LOADING) {
    return;
  }
  quickLinksStore.value.loadState = LOAD_STATE.LOADING;
  const quickLinksRequest = new QuickLinksRequest();
  // @ts-ignore
  quickLinksRequest.execute().then((resp) => {
    quickLinksStore.value.loadState = LOAD_STATE.LOADED;
    quickLinksStore.value.links = resp.data.map(ql => getLinkProps({
      iconUrl: ql.iu,
      label: ql.la,
      link: ql.li,
      target: ql.opint ? '_blank' : '_self',
    }));
  }).finally(() => {
    if (quickLinksStore.value.loadState === LOAD_STATE.LOADING) {
      quickLinksStore.value.loadState = LOAD_STATE.ERROR;
    }
  });
}

/**
 * Remove hash at start of url string if present
 * @param {string} url - original url
 */
function removeHashAtStart(url) {
  return url.startsWith('#') ? url.replace("#", '') : url;
}

/**
 * Get Interal SB link from given link
 * @param {import("./interface").TRawLink} link - raw link
 */
function getInternalLink(link) {
  return { component: 'router-link', props: { to: { path: removeHashAtStart(link.link) } }, label: link.label, imgUrl: link.iconUrl };
}

/**
 * Check if link is External link and return it otherwise return internal link
 * @param {import("./interface").TRawLink} link - raw link
 * @returns {import('./interface').TQuickLink}
 */
function checkExternalLink(link) {
  const baseSlug = !APP_SETTINGS.settings.ignoreRouteConfig && btoSBSettings && btoSBSettings.baseURLSlug ? `/${btoSBSettings.baseURLSlug}` : '/';
  const baseUrl = `${location.origin}${baseSlug}`;
  const isHistory = !APP_SETTINGS.settings.ignoreRouteConfig && btoSBSettings && btoSBSettings.isHistoryMode === '1';
  const url = link.link;
  const target = link.target || '_self';
  // SB app absolute link move to page without reload
  if (url.startsWith(baseUrl) && target !== '_blank' && isHistory) {
    const internalUrl = url.replace(baseUrl, '');
    return getInternalLink({ ...link, link: internalUrl });
  }

  return { component: 'a', props: { href: url, target }, imgUrl: link.iconUrl, label: link.label };
}

/**
 * Convert raw link into link props object
 * @param {import("./interface").TRawLink} link - raw link
 * @returns {import('./interface').TQuickLink}
 */
export function getLinkProps(link) {
  if (link.link.startsWith('http')) {
    return checkExternalLink(link);
  }

  return getInternalLink(link);
}

